import { scaleLinear } from "d3-scale";

// Return rate color scale configuration
// Light purple (low/good) -> Dark purple (high/bad) based on Baback brand color
export const RETURN_RATE_THRESHOLDS = [0, 10, 20, 35] as const;
export const RETURN_RATE_COLORS = ["#DDD6FE", "#A78BFA", "#7C3AED", "#4C1D95"] as const;

// D3 color scale for continuous color mapping
export const returnRateColorScale = scaleLinear<string>()
  .domain([...RETURN_RATE_THRESHOLDS])
  .range([...RETURN_RATE_COLORS])
  .clamp(true);

/**
 * Get the color for a given return rate value
 */
export function getReturnRateColor(rate: number): string {
  return returnRateColorScale(rate);
}

/**
 * Get the color with opacity for a given return rate value
 * Handles both hex (#rrggbb) and rgb(r, g, b) formats from d3
 */
export function getReturnRateColorWithOpacity(rate: number, opacity: number): string {
  const color = returnRateColorScale(rate);

  // Handle rgb(r, g, b) format from d3 interpolation
  const rgbMatch = color.match(/rgb\((\d+),\s*(\d+),\s*(\d+)\)/);
  if (rgbMatch) {
    return `rgba(${rgbMatch[1]}, ${rgbMatch[2]}, ${rgbMatch[3]}, ${opacity})`;
  }

  // Handle hex format
  if (color.startsWith('#')) {
    const r = parseInt(color.slice(1, 3), 16);
    const g = parseInt(color.slice(3, 5), 16);
    const b = parseInt(color.slice(5, 7), 16);
    return `rgba(${r}, ${g}, ${b}, ${opacity})`;
  }

  return color;
}

/**
 * Get color stops for CSS/SVG gradients
 */
export function getReturnRateGradientStops(): { offset: string; color: string }[] {
  const maxRate = RETURN_RATE_THRESHOLDS[RETURN_RATE_THRESHOLDS.length - 1];
  return RETURN_RATE_THRESHOLDS.map((threshold, index) => ({
    offset: `${(threshold / maxRate) * 100}%`,
    color: RETURN_RATE_COLORS[index],
  }));
}
